import { render, staticRenderFns } from "./CollegeCenter.vue?vue&type=template&id=dbebf82c&scoped=true&"
import script from "./CollegeCenter.vue?vue&type=script&lang=js&"
export * from "./CollegeCenter.vue?vue&type=script&lang=js&"
import style0 from "./CollegeCenter.vue?vue&type=style&index=0&id=dbebf82c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbebf82c",
  null
  
)

export default component.exports